import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App/index";
import * as serviceWorker from "./serviceWorker";
import config, { fusionConfig } from "./config";
import { PersistGate } from "redux-persist/integration/react";
import storeConfig from "./store/index";
import withMaintenanceCheck from "./Component/WithMaintaineceCheck"; // Ensure filename is correct
import { FusionAuthProvider } from "@fusionauth/react-sdk";

const { store, persistor } = storeConfig;

// Wrap App with the HOC
const AppWithMaintenance = withMaintenanceCheck(App);
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <FusionAuthProvider {...fusionConfig}>
        <BrowserRouter basename={config.basename}>
          <AppWithMaintenance />
        </BrowserRouter>
      </FusionAuthProvider>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// Service worker
serviceWorker.unregister();
